import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { getSelectedUser } from '../../model/selectors/getSelectedUser';
import { getSelectedWarehouse } from '../../model/selectors/getSelectedWarehouse';
import { issueInvoiceModalActions } from '../../model/slice/issueInvoiceModalSlice';
import { getInvoiceData } from 'widgets/IssueInvoiceModal/model/selectors/getInvoiceData';
import { getUserName } from 'entities/User';
import { getClientDateFormat } from 'shared/utils/helpers/getDateFormat';

export const useWatchStep = (): void => {
  const dispatch = useAppDispatch();

  const selectedUser = useAppSelector(getSelectedUser);
  const selectedWarehouse = useAppSelector(getSelectedWarehouse);
  const invoiceData = useAppSelector(getInvoiceData);

  useEffect(() => {
    if (selectedUser) {
      dispatch(issueInvoiceModalActions.changeStepData({ targetStepIndex: 0, stepData: getUserName(selectedUser) }));
    }
    if (selectedWarehouse) {
      dispatch(issueInvoiceModalActions.changeStepData({ targetStepIndex: 1, stepData: selectedWarehouse.name }));
    }
    if (invoiceData) {
      dispatch(issueInvoiceModalActions.changeStepData({ targetStepIndex: 2, stepData: getClientDateFormat(invoiceData.dueDate) }));
    }
  }, [dispatch, selectedUser, selectedWarehouse, invoiceData]);
};
